export function titleCase(s: string): string {
    return s.replace(/\w\S*/g, (word: string) => word[0].toUpperCase() + word.substr(1).toLowerCase());
}
